import { ParticipantDetails } from "../../components";
import { useInvoicePayerRegPaymentService } from "./service";
import { PurchaseOrderDetails } from "shared/components/purchaseOrder";
import PaymentComponentWrapper from "shared/components/paymentWrapper";
import RegistrationFooter from "apps/registration/components/registrationFooter";
import React from "react";

function InvoicePayerRegPayment() {
  const service = useInvoicePayerRegPaymentService();
  return (
    <React.Fragment>
      <div className="registrationWrapper">
        <div className="registrationFormPage">
          <div className="registrationFormWrapper">
            {service.transactionDetails && (
              <div className="regPaymentWrapper">
                <PaymentComponentWrapper
                  isInvoicePayer
                  amount={service.transactionDetails.amount}
                  registrationParticipantId={service.transactionDetails.registrationParticipantId}
                  invoicePayerId={service.transactionDetails.invoicePayerId}
                  purchaseOrderId={service.transactionDetails.purchaseOrder.purchaseOrderId}
                  successHandler={service.paymentSuccessHandler}
                  onAmountMismatch={service.refetchInvoicePaymentRequest}
                  showCardIcons={service.regDetails.showCardIcons}
                  customHeader={
                    <ParticipantDetails
                      fullName={service.transactionDetails.registrationParticipant.fullName}
                      workEmail={service.transactionDetails.registrationParticipant.workEmail}
                      organizationName={service.transactionDetails.registrationParticipant.organizationName}
                    />
                  }
                />
                <PurchaseOrderDetails
                  purchaseOrder={service.transactionDetails.purchaseOrder}
                  originatingFormName={
                    service.transactionDetails.originatingFormName ?? service.transactionDetails.programName
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
}

export default InvoicePayerRegPayment;
